module.exports = __webpack_public_path__ + "media/images/flags/32/Czech-Republic-0087728a5c2ea7895d9c0774ee97f5b2.png";